/* eslint-disable
    block-scoped-var,
    default-case,
    no-var,
    one-var,
    prefer-const,
    prefer-rest-params,
    react/prefer-stateless-function,
    react/prop-types,
    vars-on-top
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * DS205: Consider reworking code to avoid use of IIFEs
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import classNames from 'classnames';
import $ from 'jquery';
import React from 'react';
import createReactClass from 'create-react-class';
import PureRenderMixin from 'react-addons-pure-render-mixin';
import reactUpdate from 'immutability-helper';
import _ from 'underscore';
import * as MaterialConstants from 'notebook/protocols/MaterialConstants';

const {LEVEL_MATERIAL, LEVEL_COMPONENT} = MaterialConstants;

import * as StepConstants from 'notebook/protocols/StepConstants';

const {EditorKey} = StepConstants;

import formatters from 'notebook/mediocre/formatted-text/formatters';

import PropTypes from 'prop-types';

import EditableComponent from 'notebook/mediocre/core-ui/EditableComponent';
import EditableList from 'notebook/mediocre/selection/text/EditableListMixin';
import MultiSelectLinearList from 'notebook/mediocre/selection/block/MultiSelectLinearListMixin';
import wyciwyp from 'notebook/mediocre/clipboard/wyciwyp';
import ProtocolStoreTransforms from 'notebook/protocols/ProtocolStoreTransforms';
import * as selutil from 'notebook/mediocre/selection/text/SelUtil';

function makeComponent() {
  return ProtocolStoreTransforms.makeComponent(...arguments);
}
function makeMaterial() {
  return ProtocolStoreTransforms.makeMaterial(...arguments);
}

class ComponentEditable extends React.Component {
  static propTypes = {
    component: PropTypes.shape({
      cid: PropTypes.string.isRequired,
      raw_text: PropTypes.string.isRequired,
      formats: PropTypes.object.isRequired,
    }),
    index: PropTypes.arrayOf(PropTypes.number).isRequired,
    locked: PropTypes.bool,
    spellCheck: PropTypes.bool.isRequired,
  };

  render() {
    return (
      <EditableComponent
        // eslint-disable-next-line no-restricted-syntax
        {..._.extend({}, this.props, {
          className: classNames(this.props.className, 'component-editable', 'multi-editable'),
          allowRichText: true,
          cid: this.props.component.cid,
          text: this.props.component.raw_text,
          formats: this.props.component.formats,
          spellCheck: this.props.spellCheck,
        })}
      />
    );
  }
}

class MaterialEditable extends React.Component {
  static propTypes = {
    material: PropTypes.shape({
      cid: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      formats: PropTypes.object.isRequired,
    }),
    index: PropTypes.arrayOf(PropTypes.number).isRequired,
    locked: PropTypes.bool,
    spellCheck: PropTypes.bool.isRequired,
  };

  render() {
    return (
      <EditableComponent
        // eslint-disable-next-line no-restricted-syntax
        {..._.extend({}, this.props, {
          className: classNames(this.props.className, 'material-editable', 'multi-editable'),
          allowRichText: true,
          cid: this.props.material.cid,
          text: this.props.material.name,
          formats: this.props.material.formats,
          spellCheck: this.props.spellCheck,
        })}
      />
    );
  }
}

const MaterialsEditor = createReactClass({
  mixins: [EditableList, MultiSelectLinearList, PureRenderMixin],

  multiSelectKey() {
    return 'materials';
  },

  propTypes: {
    protocol: PropTypes.object.isRequired,
    storeState: PropTypes.func.isRequired,
    restoreState: PropTypes.func.isRequired,
    jumpTo: PropTypes.func.isRequired,
    formatHandler: PropTypes.func.isRequired,
    updateProtocol: PropTypes.func, // omitted if locked
    spellCheck: PropTypes.bool.isRequired,
    isLockedWithEditWarn: PropTypes.func.isRequired,
  },

  isLockedWithEditWarn() {
    return this.props.isLockedWithEditWarn();
  },

  getMaterials() {
    return this.props.protocol.materials;
  },

  setMaterials(newMaterials) {
    this.props.updateProtocol({
      materials: newMaterials,
    });
  },

  get(index) {
    return ProtocolStoreTransforms.getMaterialByIndex(this.props.protocol, index);
  },

  materialTabHandler(index, e) {
    const {shiftKey} = e;
    const models = this.getMaterials();
    const [materialIndex] = Array.from(index);
    const {material} = this.get(index);

    const dir = shiftKey ? -1 : 1;
    if (dir === 1 && materialIndex > 0) {
      // Only allow indenting, and if it's not the first element.
      const newComponent = makeComponent(material.name, material.formats);
      // Combine components
      const toAddComponents = [newComponent].concat(material.components);
      // Remove old material
      const newModels = reactUpdate(models, {$splice: [[materialIndex, 1]]});
      // Replace prev components with combined components
      newModels[materialIndex - 1] = reactUpdate(newModels[materialIndex - 1], {
        components: {$push: toAddComponents},
      });

      this.setMaterials(newModels);
      // Save selection for restoring on rerender.
      const selection = selutil.getSelectionIndices(e);
      selection.cid = newComponent.cid;
      this.props.requestSelection({selection});
    }
  },

  componentTabHandler(index, e) {
    const {shiftKey} = e;
    const models = this.getMaterials();
    const [materialIndex, componentIndex] = Array.from(index);
    const {material, component} = this.get(index);

    const dir = shiftKey ? -1 : 1;
    if (dir === -1) {
      // Replace parent material
      const parentMaterial = reactUpdate(material, {
        components: {$splice: [[componentIndex, material.components.length - componentIndex]]},
      });
      // Extract components
      const components = models[materialIndex].components.slice(componentIndex + 1);
      // Make new material
      const newMaterial = makeMaterial(component.raw_text, component.formats, components);
      // Insert/replace materials
      const newModels = reactUpdate(models, {$splice: [[materialIndex, 1, parentMaterial, newMaterial]]});

      this.setMaterials(newModels);
      // Save selection for restoring on rerender.
      const selection = selutil.getSelectionIndices(e);
      selection.cid = newMaterial.cid;
      this.props.requestSelection({selection});
    }
  },

  _moveHelper(e, target, level) {
    const {up, beginning} = e;
    if (target != null) {
      const text = level === LEVEL_MATERIAL ? target.name : target.raw_text;
      const pos = beginning ? 0 : text.length;
      this.props.requestSelection({selection: {cid: target.cid, start: pos, end: pos}});
    } else {
      this.clearSelection();
      const location = beginning ? 'start' : 'end';
      const section = up ? EditorKey.INTRO : EditorKey.STEPS;
      const row = up ? 'last' : 'first';
      this.props.jumpTo({section, location, row});
    }
  },

  componentMoveHandler(index, e) {
    const {up} = e;
    const models = this.getMaterials();
    const [materialIndex, componentIndex] = Array.from(index);
    const {material} = this.get(index);

    const [target, level] = Array.from(
      up
        ? componentIndex > 0
          ? [material.components[componentIndex - 1], LEVEL_COMPONENT]
          : [material, LEVEL_MATERIAL]
        : componentIndex + 1 < material.components.length
          ? [material.components[componentIndex + 1], LEVEL_COMPONENT]
          : [models[materialIndex + 1] || null, LEVEL_MATERIAL]
    );

    this._moveHelper(e, target, level);
  },

  materialMoveHandler(index, e) {
    const {up} = e;
    const models = this.getMaterials();
    const [materialIndex] = Array.from(index);
    const {material} = this.get(index);

    const [target, level] = Array.from(
      (() => {
        if (up) {
          if (materialIndex > 0) {
            const prevMaterial = models[materialIndex - 1];
            if (prevMaterial.components.length) {
              return [prevMaterial.components[prevMaterial.components.length - 1], LEVEL_COMPONENT];
            } else {
              return [prevMaterial, LEVEL_MATERIAL];
            }
          } else {
            return [null, null];
          }
        } else if (material.components.length) {
          return [material.components[0], LEVEL_COMPONENT];
        } else {
          return [models[materialIndex + 1] || null, LEVEL_MATERIAL];
        }
      })()
    );

    this._moveHelper(e, target, level);
  },

  materialUpdateHandler(index, e) {
    const {text, formats} = e;
    const models = this.getMaterials();
    const {material} = this.get(index);

    const newModel = reactUpdate(material, {$merge: {name: text, formats}});
    const newModels = reactUpdate(models, {$splice: [[index, 1, newModel]]});

    this.setMaterials(newModels);
    this.props.requestSelection({selection: selutil.getSelectionIndices(e)});
  },

  componentUpdateHandler(index, e) {
    const {text, formats} = e;
    const models = this.getMaterials();
    const [materialIndex, componentIndex] = Array.from(index);
    const {material, component} = this.get(index);

    const newComponent = reactUpdate(component, {$merge: {raw_text: text, formats}});
    const newMaterial = reactUpdate(material, {
      components: {$splice: [[componentIndex, 1, newComponent]]},
    });
    const newModels = reactUpdate(models, {$splice: [[materialIndex, 1, newMaterial]]});

    this.setMaterials(newModels);
    this.props.requestSelection({selection: selutil.getSelectionIndices(e)});
  },

  multiGetTextForCopy() {
    let middleMaterials, topOrphans;
    const {start, end} = this.sortedMultiRange();
    const models = this.getMaterials();
    let [topMaterials] = Array.from(this._splitAfter(models, end));
    [topMaterials, topOrphans, middleMaterials] = Array.from(this._splitBefore(topMaterials, start));
    const items = [];
    for (var component of Array.from(topOrphans)) {
      items.push(`  - ${component.raw_text}`);
    }
    for (const material of Array.from(middleMaterials)) {
      items.push(material.name);
      for (component of Array.from(material.components)) {
        items.push(`  - ${component.raw_text}`);
      }
    }
    return items.join('\n');
  },

  multiGetHTMLForCopy() {
    let middleMaterials, topOrphans;
    const {start, end} = this.sortedMultiRange();
    const models = this.getMaterials();
    let [topMaterials] = Array.from(this._splitAfter(models, end));
    [topMaterials, topOrphans, middleMaterials] = Array.from(this._splitBefore(topMaterials, start));
    const materials = [...Array.from(middleMaterials)];
    if (topOrphans.length) {
      const newTopMaterial = makeMaterial('', formatters.defaultFormats(), topOrphans);
      materials.unshift(newTopMaterial);
    }
    const $ul = $('<ul></ul>');
    for (const m of Array.from(materials)) {
      const $materialLi = $('<li></li>');
      $materialLi.html(formatters.renderHTML(m.name, m.formats));
      if (m.components.length) {
        const $componentsUl = $('<ul></ul>');
        for (const c of Array.from(m.components)) {
          $componentsUl.append($('<li></li>').html(formatters.renderHTML(c.raw_text, c.formats)));
        }
        $materialLi.append($componentsUl);
      }
      $ul.append($materialLi);
    }
    return $ul[0].outerHTML;
  },

  pasteHandler(index, e) {
    let lastComponent, lastItem, lastMaterial, middleMaterials, newMaterials, topOrphans;
    const {before, selected, after, originalEvent} = e;

    const {material, component} = this.get(index);
    const models = this.getMaterials();
    const parts = wyciwyp.processClipboard(originalEvent.clipboardData);

    const item = component != null ? component : material;
    const beforeFormats = formatters.splitFormats(item.formats, before.length).before;
    const afterFormats = formatters.splitFormats(item.formats, selected.length + before.length).after;
    // Split above and below the current item
    let [topMaterials, bottomOrphans, bottomMaterials] = Array.from(this._splitAfter(models, index));
    // eslint-disable-next-line no-unused-vars
    [topMaterials, topOrphans, middleMaterials] = Array.from(this._splitBefore(topMaterials, index));

    // Reconstruct middle section...
    const newTopOrphans = [];
    const newMiddleMaterials = [];

    // ...starting with the current item
    if (component != null) {
      const newComponent = reactUpdate(component, {$merge: {raw_text: before, formats: beforeFormats}});
      newTopOrphans.push(newComponent);
      lastItem = newComponent;
      lastComponent = newComponent;
    } else {
      const newMaterial = reactUpdate(material, {
        $merge: {
          name: before,
          formats: beforeFormats,
          components: [],
        },
      });
      newMiddleMaterials.push(newMaterial);
      lastItem = newMaterial;
      lastMaterial = newMaterial;
    }

    function addComponent(text, formats) {
      // Create component and add it to appropriate part of middle section.
      const c = makeComponent(text, formats);
      if (lastMaterial != null) {
        lastMaterial.components.push(c);
      } else {
        newTopOrphans.push(c);
      }
      lastItem = c;
      lastComponent = c;
    }

    function addText(text, formats) {
      // Append text to last added material/component
      // (for the text that was split on paste, ie. before and after)
      if (lastItem === lastMaterial) {
        lastMaterial.formats = formatters.joinFormats(
          lastMaterial.formats,
          formats,
          lastMaterial.name.length
        );
        lastMaterial.name += text;
        return {cid: lastMaterial.cid, pos: lastMaterial.name.length};
      } else {
        lastComponent.formats = formatters.joinFormats(
          lastComponent.formats,
          formats,
          lastComponent.raw_text.length
        );
        lastComponent.raw_text += text;
        return {cid: lastComponent.cid, pos: lastComponent.raw_text.length};
      }
    }

    function addMaterial(text, formats) {
      // Create material and add it to middle section.
      const m = makeMaterial(text, formats);
      newMiddleMaterials.push(m);
      lastItem = m;
      lastMaterial = m;
    }

    // Iterate through pasted parts, and add them to middle section.
    for (let i = 0; i < parts.length; i++) {
      const part = parts[i];
      const {type, formats, text} = part;
      if (i === 0) {
        addText(text, formats);
      } else if (type === wyciwyp.DESC) {
        addComponent(text, formats);
      } else {
        addMaterial(text, formats);
      }
    }
    const selInfo = addText(after, afterFormats);

    // Compute new selection
    const pos = selInfo.pos - after.length;
    const newSelection = {cid: selInfo.cid, start: pos, end: pos};

    // Recombine sections, sticking in new middle sections
    let [newTopMaterials, splitBeforeIndex] = Array.from(
      this._merge(topMaterials, newTopOrphans, newMiddleMaterials)
    );
    // eslint-disable-next-line no-unused-vars
    [newMaterials, splitBeforeIndex] = Array.from(
      this._merge(newTopMaterials, bottomOrphans, bottomMaterials)
    );

    // Update state
    this.setMaterials(newMaterials);
    this.props.requestSelection({selection: newSelection});
  },

  splitHandler(index, e) {
    let formats, levels, orphans, target;
    const {before, selected, after} = e;
    const {material, component, model, level} = this.get(index);

    const beforeFormats = formatters.splitFormats(model.formats, before.length).before;
    const afterFormats = formatters.splitFormats(model.formats, selected.length + before.length).after;

    let parts = [before, after];
    let cursor = {index: 1, offset: 0};

    if (e.shiftKey) {
      formats = [beforeFormats, afterFormats];
      levels = // enter/exit material
        level === LEVEL_MATERIAL ? [LEVEL_MATERIAL, LEVEL_COMPONENT] : [LEVEL_COMPONENT, LEVEL_MATERIAL];
    } else if (parts[0].length === parts[1].length && parts[1].length === 0) {
      formats = [beforeFormats];
      levels = [LEVEL_MATERIAL]; // if empty, go to outer level.
      parts = [''];
      cursor = {index: 0, offset: 0};
    } else {
      formats = [beforeFormats, afterFormats];
      levels = [level, level]; // normal split
    }

    const models = this.getMaterials();
    const [materialIndex, componentIndex] = Array.from(index);

    let newMaterial = _.clone(material);
    newMaterial.components = [];
    const newMaterials = [];
    newMaterials.push(newMaterial);

    let cursorCountdown = cursor.index;

    if (component) {
      newMaterial.components = material.components.slice(0, componentIndex);
      orphans = material.components.slice(componentIndex + 1);
    } else {
      newMaterial.name = parts[0];
      newMaterial.formats = formats[0];
      if (levels[0] !== LEVEL_MATERIAL) {
        throw new Error('Unsupported scenario.');
      }

      // we've already handled the first part.
      parts.shift();
      levels.shift();
      formats.shift();
      cursorCountdown--;
      target = newMaterial;
      orphans = material.components.slice();
    }

    for (const [stepText, stepLevel, stepFormats] of Array.from(_.zip(parts, levels, formats))) {
      var added;
      var newComponent;
      switch (stepLevel) {
        case LEVEL_MATERIAL:
          newMaterial = makeMaterial(stepText, stepFormats);
          added = newMaterial;
          newMaterials.push(newMaterial);
          break;
        case LEVEL_COMPONENT:
          newComponent = makeComponent(stepText, stepFormats);
          added = newComponent;
          newMaterials[newMaterials.length - 1].components.push(newComponent);
          break;
      }
      if (cursorCountdown === 0) {
        target = added;
      }
      cursorCountdown--;
    }

    newMaterials[newMaterials.length - 1].components.push(...Array.from(orphans || []));

    const newModels = reactUpdate(models, {$splice: [[materialIndex, 1, ...Array.from(newMaterials)]]});

    this.setMaterials(newModels);
    this.props.requestSelection({selection: {cid: target.cid, start: cursor.offset, end: cursor.offset}});
  },

  mergeHelper(index1, index2) {
    // index1 and index2 should be adjacent.
    let newModels;
    const models = this.getMaterials();
    const first = this.get(index1);
    const second = this.get(index2);

    switch (first.level) {
      case LEVEL_MATERIAL: {
        let [materialIndex] = Array.from(index1);
        let {material} = first;
        switch (second.level) {
          case LEVEL_MATERIAL: {
            const nextMaterial = second.material;
            const orphaned = nextMaterial.components;
            const newMaterial = reactUpdate(material, {
              components: {$push: orphaned},
              $merge: {
                name: material.name + nextMaterial.name,
                formats: formatters.joinFormats(material.formats, nextMaterial.formats, material.name.length),
              },
            });
            newModels = reactUpdate(models, {$splice: [[materialIndex, 2, newMaterial]]});
            break;
          }
          case LEVEL_COMPONENT: {
            const {component} = second;
            const newMaterial = reactUpdate(material, {
              components: {$splice: [[0, 1]]},
              $merge: {
                name: material.name + component.raw_text,
                formats: formatters.joinFormats(material.formats, component.formats, material.name.length),
              },
            });
            newModels = reactUpdate(models, {$splice: [[materialIndex, 1, newMaterial]]});
            break;
          }
        }
        break;
      }

      case LEVEL_COMPONENT: {
        const [materialIndex, componentIndex] = Array.from(index1);
        const {material, component} = first;
        switch (second.level) {
          case LEVEL_MATERIAL: {
            const nextMaterial = second.material;
            const orphaned = nextMaterial.components;
            let newComponent = reactUpdate(component, {
              $merge: {
                raw_text: component.raw_text + nextMaterial.name,
                formats: formatters.joinFormats(
                  component.formats,
                  nextMaterial.formats,
                  component.raw_text.length
                ),
              },
            });
            const newMaterial = reactUpdate(material, {
              components: {$splice: [[componentIndex, 1, newComponent, ...Array.from(orphaned)]]},
            });
            newModels = reactUpdate(models, {$splice: [[materialIndex, 2, newMaterial]]});
            break;
          }
          case LEVEL_COMPONENT: {
            const nextComponent = second.component;
            const newComponent = reactUpdate(component, {
              $merge: {
                raw_text: component.raw_text + nextComponent.raw_text,
                formats: formatters.joinFormats(
                  component.formats,
                  nextComponent.formats,
                  component.raw_text.length
                ),
              },
            });
            const newMaterial = reactUpdate(material, {
              components: {$splice: [[componentIndex, 2, newComponent]]},
            });
            newModels = reactUpdate(models, {
              $splice: [[materialIndex, 1, newMaterial]],
            });
            break;
          }
        }
        break;
      }
    }

    const pos = first.level === LEVEL_MATERIAL ? first.model.name.length : first.model.raw_text.length;
    this.props.requestSelection({selection: {cid: first.model.cid, start: pos, end: pos}});
    this.setMaterials(newModels);
  },

  componentMergeUpHandler(index, e) {
    const {anchor} = e;
    const models = this.getMaterials();
    const {material} = this.get(index);
    const [materialIndex, componentIndex] = Array.from(index);

    if (anchor) {
      if (componentIndex + 1 < material.components.length) {
        this.mergeHelper(index, [materialIndex, componentIndex + 1]);
      } else if (materialIndex + 1 < models.length) {
        this.mergeHelper(index, [materialIndex + 1]);
      }
    } else if (componentIndex > 0) {
      this.mergeHelper([materialIndex, componentIndex - 1], index);
    } else {
      this.mergeHelper([materialIndex], index);
    }
  },

  materialMergeUpHandler(index, e) {
    const {anchor} = e;
    const models = this.getMaterials();
    const {material} = this.get(index);
    const [materialIndex] = Array.from(index);

    if (anchor) {
      if (material.components.length) {
        this.mergeHelper(index, [materialIndex, 0]);
      } else if (materialIndex + 1 < models.length) {
        this.mergeHelper(index, [materialIndex + 1]);
      }
    } else if (materialIndex > 0) {
      const prevMaterial = models[materialIndex - 1];
      if (prevMaterial.components.length) {
        this.mergeHelper([materialIndex - 1, prevMaterial.components.length - 1], index);
      } else {
        this.mergeHelper([materialIndex - 1], index);
      }
    }
  },

  _splitAfter(materials, index) {
    // Splits a list of materials after the specified item
    // Returns an array of [materials, orphaned components, materials]
    let after, before, mIndex, orphans;
    if (index.length === 1) {
      // material
      mIndex = index[0];
      const material = materials[mIndex];
      orphans = material.components;

      const newMaterial = reactUpdate(material, {components: {$set: []}});
      before = reactUpdate(materials, {
        $splice: [[mIndex, materials.length - mIndex, newMaterial]],
      });
      after = materials.slice(mIndex + 1);
      return [before, orphans, after];
    } else {
      // component
      let cIndex;
      [mIndex, cIndex] = Array.from(index);
      before = materials.slice(0, mIndex + 1);
      after = materials.slice(mIndex + 1);
      const lastMaterial = before[mIndex];
      const notOrphans = lastMaterial.components.slice(0, cIndex + 1);
      orphans = lastMaterial.components.slice(cIndex + 1);
      before[mIndex] = reactUpdate(lastMaterial, {components: {$set: notOrphans}});
      return [before, orphans, after];
    }
  },

  _splitBefore(materials, index) {
    // Splits a list of materials before the specified item
    // Returns an array of [materials, orphaned components, materials]
    let cIndex, mIndex;
    if (index.length === 1) {
      // material
      [mIndex] = Array.from(index);
      if (mIndex === 0) {
        return [[], [], materials];
      } else {
        const prevMaterial = materials[mIndex - 1];
        cIndex = prevMaterial.components.length - 1;
        return this._splitAfter(materials, [mIndex - 1, cIndex]);
      }
    } else {
      // component
      [mIndex, cIndex] = Array.from(index);
      if (cIndex === 0) {
        return this._splitAfter(materials, [mIndex]);
      } else {
        return this._splitAfter(materials, [mIndex, cIndex - 1]);
      }
    }
  },

  _merge(before, orphans, after) {
    let index = null;
    if (orphans.length > 0) {
      if (before.length === 0) {
        before = [makeMaterial('', formatters.defaultFormats())];
      } else {
        before = before.slice();
      }
      const mIndex = before.length - 1;
      const cIndex = before[mIndex].components.length;
      index = [mIndex, cIndex];
      before[mIndex] = reactUpdate(before[mIndex], {components: {$push: orphans}});
    }
    const newMaterials = before.concat(after);
    return [newMaterials, index];
  },

  previousIndex(index) {
    const {materials} = this.props.protocol;
    const {model, component} = this.get(index);
    const [materialIndex, componentIndex] = Array.from(index);

    if (model === component) {
      if (componentIndex === 0) {
        return [materialIndex];
      } else {
        return [materialIndex, componentIndex - 1];
      }
    } else if (materialIndex === 0) {
      return [0];
    } else {
      const comps = materials[materialIndex - 1].components.length;
      if (comps) {
        return [materialIndex - 1, comps - 1];
      } else {
        return [materialIndex - 1];
      }
    }
  },

  nextIndex(index) {
    const {model, material} = this.get(index);
    const [materialIndex, componentIndex] = Array.from(index);

    if (model === material) {
      if (material.components.length) {
        return [materialIndex, 0];
      } else {
        return [Math.min(materialIndex + 1, this.props.protocol.materials.length - 1)];
      }
    } else if (componentIndex + 1 < material.components.length) {
      return [materialIndex, componentIndex + 1];
    } else if (materialIndex + 1 > this.props.protocol.materials.length - 1) {
      return [materialIndex, componentIndex];
    } else {
      return [Math.min(materialIndex + 1, this.props.protocol.materials.length - 1)];
    }
  },

  firstIndex() {
    return [0];
  },

  lastIndex() {
    const {materials} = this.props.protocol;
    const materialIndex = this.props.protocol.materials.length - 1;
    const material = materials[materialIndex];
    if (material && material.components.length) {
      return [materialIndex, material.components.length - 1];
    } else {
      return [materialIndex];
    }
  },

  compareIndex(a, b) {
    // Returns -1 if a is before b, 0 if a is b, 1 if a is after
    if (a.length === 1) {
      a = [a[0], -1];
    }
    if (b.length === 1) {
      b = [b[0], -1];
    }

    if (a[0] < b[0]) {
      return -1;
    } else if (a[0] > b[0]) {
      return 1;
    } else if (a[1] < b[1]) {
      return -1;
    } else if (a[1] > b[1]) {
      return 1;
    } else {
      return 0;
    }
  },

  tabRangeHandler(e) {
    let components, material, middleMaterials, newEnd, newMaterials, newStart, splitBeforeIndex, topOrphans;
    const {start, end} = e;
    const models = this.getMaterials();

    let [topMaterials, bottomOrphans, bottomMaterials] = Array.from(this._splitAfter(models, end));
    [topMaterials, topOrphans, middleMaterials] = Array.from(this._splitBefore(topMaterials, start));

    //   topMaterials
    // ================= start
    //    topOrphans
    //                  >-- to become components or materials.
    //  middleMaterials
    // =======end======= end
    //   bottomOrphans
    //  bottomMaterials

    if (!e.shiftKey) {
      // Combine topOrphan and middleMaterials into components
      components = [];
      components.push(...Array.from(topOrphans || []));
      for (material of Array.from(middleMaterials)) {
        components.push(makeComponent(material.name, material.formats));
        components.push(...Array.from(material.components || []));
      }

      // Merge
      const modified = components.length;
      components.push(...Array.from(bottomOrphans || []));
      [newMaterials, splitBeforeIndex] = Array.from(this._merge(topMaterials, components, bottomMaterials));

      newStart = splitBeforeIndex;
      newEnd = [splitBeforeIndex[0], splitBeforeIndex[1] + modified - 1];
    } else {
      // Combine topOrphan and middleMaterials into materials
      const materials = [];
      for (var component of Array.from(topOrphans)) {
        materials.push(makeMaterial(component.raw_text, component.formats));
      }
      for (material of Array.from(middleMaterials)) {
        const newMidMaterial = reactUpdate(material, {components: {$set: []}});
        materials.push(newMidMaterial);
        for (component of Array.from(material.components)) {
          materials.push(makeMaterial(component.raw_text, component.formats));
        }
      }

      // Merge
      topMaterials = topMaterials.concat(materials);
      [newMaterials, splitBeforeIndex] = Array.from(
        this._merge(topMaterials, bottomOrphans, bottomMaterials)
      );
      newStart = [topMaterials.length - materials.length];
      newEnd = [topMaterials.length - 1];
    }

    this.setMaterials(newMaterials);
    this.setMultiIndices({
      start: newStart,
      end: newEnd,
    });
  },

  formatRangeHandler({start, end, format}) {
    let middleMaterials, newMaterials, splitBeforeIndex, topOrphans;
    const materials = this.getMaterials();

    // Split the materials to access the items of interest
    let [topMaterials, bottomOrphans, bottomMaterials] = Array.from(this._splitAfter(materials, end));
    [topMaterials, topOrphans, middleMaterials] = Array.from(this._splitBefore(topMaterials, start));

    //   topMaterials
    // ================= start
    //    topOrphans
    //                  >-- to be formatted
    //  middleMaterials
    // =======end======= end
    //   bottomOrphans
    //  bottomMaterials

    // Find all components and materials in the range, format them, and then create a map of cid to new text.
    const allComponents = topOrphans.concat(
      ...Array.from(middleMaterials.map((material) => material.components) || [])
    );
    const cids = allComponents.concat(middleMaterials).map((item) => item.cid);
    const oldFmtTexts = allComponents
      .map((item) => ({text: item.raw_text, formats: item.formats}))
      .concat(middleMaterials.map((item) => ({text: item.name, formats: item.formats})));
    const newFmtTexts = formatters.formatTexts(oldFmtTexts, {format});
    const fmtTextMap = _.object(cids, newFmtTexts);

    // Iterate over topOrphans and middleMaterials, and apply the mapping to make the new items.
    function formattedComponent(item) {
      const {text, formats} = fmtTextMap[item.cid];
      return reactUpdate(item, {$merge: {raw_text: text, formats}});
    }

    function formattedMaterial(item) {
      const {text, formats} = fmtTextMap[item.cid];
      return reactUpdate(item, {
        $merge: {
          name: text,
          formats,
          components: item.components.map((i) => formattedComponent(i)),
        },
      });
    }

    const newTopOrphans = topOrphans.map((orphan) => formattedComponent(orphan));
    const newMiddleMaterials = middleMaterials.map((material) => formattedMaterial(material));

    // Merge the materials back together.
    [topMaterials, splitBeforeIndex] = Array.from(
      this._merge(topMaterials, newTopOrphans, newMiddleMaterials)
    );
    // eslint-disable-next-line no-unused-vars
    [newMaterials, splitBeforeIndex] = Array.from(this._merge(topMaterials, bottomOrphans, bottomMaterials));

    this.setMaterials(newMaterials);
  },

  inputRangeHandler({start, end, text}) {
    const {level} = this.get(start);
    const item =
      level === LEVEL_MATERIAL
        ? makeMaterial(text, formatters.defaultFormats())
        : makeComponent(text, formatters.defaultFormats());
    this.deleteRangeHelper({start, end, replacement: {item, level}});
  },

  deleteRangeHandler({start, end}) {
    this.deleteRangeHelper({start, end});
  },

  deleteRangeHelper({start, end, replacement}) {
    let cid, middleMaterials, pos, selection, topOrphans;
    const models = this.getMaterials();

    let [topMaterials, bottomOrphans, bottomMaterials] = Array.from(this._splitAfter(models, end));
    // eslint-disable-next-line no-unused-vars
    [topMaterials, topOrphans, middleMaterials] = Array.from(this._splitBefore(topMaterials, start));

    //   topMaterials
    // ================= start
    //    topOrphans
    //                  >-- to be deleted. selection to be restored to end of topMaterials.
    //  middleMaterials
    // =======end======= end
    //   bottomOrphans
    //  bottomMaterials

    // Merge without topOrphans and middleMaterials
    if (replacement != null) {
      if (replacement.level === LEVEL_MATERIAL) {
        topMaterials = reactUpdate(topMaterials, {$push: [replacement.item]});
        pos = replacement.item.name.length;
      } else {
        bottomOrphans = reactUpdate(bottomOrphans, {$unshift: [replacement.item]});
        pos = replacement.item.raw_text.length;
      }
      selection = {cid: replacement.item.cid, start: pos, end: pos};
    }
    // eslint-disable-next-line no-unused-vars
    let [newMaterials, splitBeforeIndex] = Array.from(
      this._merge(topMaterials, bottomOrphans, bottomMaterials)
    );
    if (newMaterials.length === 0) {
      newMaterials = [makeMaterial('', formatters.defaultFormats())];
    }

    // Compute selection
    if (replacement != null) {
      // handled above
    } else if (topMaterials.length) {
      const lastMaterial = topMaterials[topMaterials.length - 1];
      if (lastMaterial.components.length) {
        const lastComponent = lastMaterial.components[lastMaterial.components.length - 1];
        ({cid} = lastComponent);
        pos = lastComponent.raw_text.length;
      } else {
        ({cid} = lastMaterial);
        pos = lastMaterial.name.length;
      }
      selection = {cid, start: pos, end: pos};
    } else {
      selection = {cid: newMaterials[0].cid, start: 0, end: 0};
    }

    this.setMaterials(newMaterials);
    this.props.requestSelection({selection});
  },

  render() {
    return (
      <div className="materials-editor" data-editor={this.props.editorKey}>
        {this.renderFocusBearer()}
        <ul key="materials" className="materials">
          {(() => {
            const result = [];
            const iterable = this.getMaterials();
            for (var materialIndex = 0; materialIndex < iterable.length; materialIndex++) {
              var material = iterable[materialIndex];
              let className = 'material';
              if (this.isSelected([materialIndex])) {
                className += ' selected';
              }

              const mIndex = [materialIndex];
              result.push(
                <li key={material.cid} className={className}>
                  <MaterialEditable
                    key="editable"
                    material={material}
                    index={mIndex}
                    tabHandler={this.materialTabHandler.bind(this, mIndex)}
                    formatHandler={this.props.formatHandler.bind(null, mIndex)}
                    moveHandler={this.materialMoveHandler.bind(this, mIndex)}
                    updateHandler={this.materialUpdateHandler.bind(this, mIndex)}
                    pasteHandler={this.pasteHandler.bind(this, mIndex)}
                    mergeUpHandler={this.materialMergeUpHandler.bind(this, mIndex)}
                    splitHandler={this.splitHandler.bind(this, mIndex)}
                    multiSelectHandler={this.multiArrowSelectHandler.bind(this, mIndex)}
                    mouseDownHandler={this.multiEditableMouseDownHandler.bind(this, {
                      start: mIndex,
                      active: true,
                    })}
                    mouseOverHandler={this.multiEditableMouseOverHandler.bind(this, mIndex)}
                    storeState={this.props.storeState}
                    restoreState={this.props.restoreState}
                    locked={this.props.locked}
                    spellCheck={this.props.spellCheck}
                  />
                  <ul key="components" className="components">
                    {(() => {
                      const result1 = [];
                      for (
                        let componentIndex = 0;
                        componentIndex < material.components.length;
                        componentIndex++
                      ) {
                        const component = material.components[componentIndex];
                        let compClassName = 'component';
                        if (this.isSelected([materialIndex, componentIndex])) {
                          compClassName += ' selected';
                        }
                        const cIndex = [materialIndex, componentIndex];
                        result1.push(
                          <li key={component.cid} className={compClassName}>
                            <ComponentEditable
                              component={component}
                              index={cIndex}
                              tabHandler={this.componentTabHandler.bind(this, cIndex)}
                              formatHandler={this.props.formatHandler.bind(null, cIndex)}
                              moveHandler={this.componentMoveHandler.bind(this, cIndex)}
                              updateHandler={this.componentUpdateHandler.bind(this, cIndex)}
                              pasteHandler={this.pasteHandler.bind(this, cIndex)}
                              mergeUpHandler={this.componentMergeUpHandler.bind(this, cIndex)}
                              splitHandler={this.splitHandler.bind(this, cIndex)}
                              multiSelectHandler={this.multiArrowSelectHandler.bind(this, cIndex)}
                              mouseDownHandler={this.multiEditableMouseDownHandler.bind(this, {
                                start: cIndex,
                                active: true,
                              })}
                              mouseOverHandler={this.multiEditableMouseOverHandler.bind(this, cIndex)}
                              storeState={this.props.storeState}
                              restoreState={this.props.restoreState}
                              locked={this.props.locked}
                              spellCheck={this.props.spellCheck}
                            />
                          </li>
                        );
                      }
                      return result1;
                    })()}
                  </ul>
                </li>
              );
            }
            return result;
          })()}
        </ul>
      </div>
    );
  },
});

export default MaterialsEditor;
